import { render, staticRenderFns } from "./VliveComment.vue?vue&type=template&id=4d3c4a3a&"
import script from "./VliveComment.vue?vue&type=script&lang=js&"
export * from "./VliveComment.vue?vue&type=script&lang=js&"
import style0 from "./VliveComment.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports